import {grey300, grey600, grey800} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';

const styles = {
    empty: {
        fullHeight: {
            height: 'calc(100vh - 150px)',
            display: 'flex',
            flexFlow: 'column'
        },
        container: {
            animation: 'fadein 0.5s',
            marginRight: 0,
            marginLeft: 0,
            flex: '1 1 auto',
            display: 'flex',
            flexFlow: 'column',
            // alignItems: 'center',
            justifyContent: 'center'
        },
        image: {
            height: 175,
        },
        textContainer: {
            paddingTop: 30,
            paddingBottom: 30,
            textAlign: 'center',
            marginBottom: 'auto'
        },
        title: {
            fontSize: 20,
            fontWeight: typography.fontWeightNormal,
            color: grey800
        },
        desc: {
            fontSize: 18,
            fontWeight: typography.fontWeightLight,
            color: grey600
        },
        icon: {
            backgroundColor: grey300,
            borderRadius: 50,
            height: 50,
            width: 50,
            fontSize: 40
        }
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/push/PushPage/PushPage.css.js